import React, { useState } from 'react'
import { Button, Empty, Popconfirm } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClone, faEdit, faPlus, faTrash, faXmark } from '@fortawesome/free-solid-svg-icons'
import { gerarKey, removerAcentos } from '../../../../../../utils'

//COMPONENTS
import { Box } from '../../../../../../Components/CustomUi/box'
import { Inline } from '../../../../../../Components/CustomUi/inline'
import Input from '../../../../../../Components/CustomUi/input'
import ButtonCustom from '../../../../../../Components/ButtonCustom'
import { HeaderTable } from '../../../../../../Components/CustomUi/table/headerTable'
import { BodyTable } from '../../../../../../Components/CustomUi/table/bodyTable'
import { Render } from '../../../../../../Components/CustomUi/render'
import { RowTable } from '../../../../../../Components/CustomUi/table/rowTable'
import { RowItem } from '../../../../../../Components/CustomUi/table/rowItem'
import { mascaraOdom } from '../../../../../../services/Afins'
import { DeleteButton } from '../../../../../../Components/CustomUi/deleteButton'
import Carregando from '../../../../../../Components/CustomUi/loading'
import { ItensAditivos } from '../../../../../../services/aditivos/GET'
import { ItensPerUserLogged } from '../../../../../../services/login/permissaoUsuarioLoado'

//PROPS
interface Props {
  loading: boolean
  list_aditivos: ItensAditivos[]
  permissions: ItensPerUserLogged
  deletar: Function
  abrir: Function
  editar: Function
  buscarTabela: string
  setBuscarTabela: React.Dispatch<React.SetStateAction<string>>
  setPagination?: React.Dispatch<React.SetStateAction<number>>
  page: number
  setPage: React.Dispatch<React.SetStateAction<number>>
  total: number
  confirmar_exclusao: boolean
  setConfirmar_exclusao: React.Dispatch<React.SetStateAction<boolean>>
  id_item_atual: number
  setId_item_atual: React.Dispatch<React.SetStateAction<number>>
  nome_item_atual: string
  setNome_item_atual: React.Dispatch<React.SetStateAction<string>>
  fake_loading: boolean
  setFake_loading: React.Dispatch<React.SetStateAction<boolean>>
  filtradoAtivo: boolean
    totalRef: number
}

export const TabelaOutrosAditivos: React.FC<Props> = ({
  list_aditivos,
  permissions,
  loading,
  deletar,
  abrir,
  buscarTabela,
  setBuscarTabela,
  setPagination,
  editar,
  page,
  setPage,
  total,
  confirmar_exclusao,
  setConfirmar_exclusao,
  id_item_atual,
  setId_item_atual,
  nome_item_atual,
  setNome_item_atual,
  fake_loading,
  setFake_loading,
  filtradoAtivo,
  totalRef
}) => {
  //STATES

  function buscarAditivos(buscar_nome: string) {
    const palavraSemAcentos = removerAcentos(buscar_nome)
    return function (item) {
      const nomeSemAcentos = removerAcentos(String(item?.nome))
      return nomeSemAcentos.toLowerCase().includes(palavraSemAcentos.toLowerCase()) || !buscar_nome
    }
  }

  return (
    <Box style={{ height: 'calc(100vh - 170px)', border: 'none' }} padding={0} borderless>
      {/* <TitleH2>Lista de patrimônios</TitleH2> */}

      <Inline alignItems='center'>
        <Input placeholder='Buscar outros aditivos' value={buscarTabela} onChange={setBuscarTabela} />
        <ButtonCustom icon={<FontAwesomeIcon icon={faPlus} />} onClick={abrir}>
          Cadastrar
        </ButtonCustom>
      </Inline>

      <HeaderTable
        itens={[
          { valor: 'Nome', width: 'calc(100% - 865.5px)' },
          { valor: 'Tipo aditivo', width: '150px' },
          { valor: 'Tipo formulação', width: '150px' },
          { valor: 'Modo de uso', width: '400px' },
          { valor: 'Ações', width: '160px' },
        ]}
      />

      <BodyTable
        paginate={totalRef}
        paginateFilter={
          filtradoAtivo
            ? (list_aditivos ?? []).filter(buscarAditivos(buscarTabela)).length
            : 0
        }
        onChangeItensPage={setPagination}
        onChangePage={setPage}
        current_page={page}
        setCurrent_page={setPage}
        style={{
          height: 'calc(100vh - 170px)',
          // height: (list_aditivos ?? []).length < 8 && 'calc(100vh - 170px)',
          position: 'relative',
          overflowX: 'hidden',
          overflowY: 'scroll',
          marginTop: -10,
        }}
      >
        <Render condition={!loading}>
          {(list_aditivos ?? [])
            .filter(buscarAditivos(buscarTabela))
            .map(({ cod, nome, descricao,tipo_aditivo_nome, tipo_formulacao }, index) => {
              return (
                <RowTable key={cod} onDoubleClick={() => editar(cod, false)} style={{height: 'auto'}}>
                  <RowItem fontSize={13} width={'calc(100% - 860px)'}>
                    {nome}
                  </RowItem>
                  <RowItem fontSize={13} width={'150px'}>
                    {tipo_aditivo_nome}
                  </RowItem>
                   <RowItem fontSize={13} width={'150px'}>
                    {tipo_formulacao === 248 ? 'Líquida' : 'Sólido'}
                  </RowItem>
                   <RowItem fontSize={13} width={'400px'}>
                    {descricao}
                  </RowItem>
                  <RowItem width={'160px'} gap={10}>
                    <DeleteButton
                      open={confirmar_exclusao && id_item_atual === cod}
                      trigger={setConfirmar_exclusao}
                      onTrigger={() => {
                        setId_item_atual(cod)
                        setNome_item_atual(nome)
                      }}
                      loading={fake_loading}
                      message={`o item ${nome} será excluido!`}
                      deleteds={[nome]}
                      onDelete={() => {
                        deletar(cod)
                      }}
                      disabled={fake_loading || permissions?.exclusao === 0 || permissions?.acesso === 1}
                      disabledTrigger={permissions?.exclusao === 0 || permissions?.acesso === 1}
                      typeButtonTrigger='secondary'
                    />
                    <ButtonCustom
                      icon={<FontAwesomeIcon icon={faEdit} />}
                      onClick={() => {
                        editar(cod, false)
                      }}
                      disabled={permissions?.alteracao === 0 || permissions?.acesso === 1}
                    >
                      Editar
                    </ButtonCustom>
                  </RowItem>
                </RowTable>
              )
            })}
        </Render>

        <Render condition={list_aditivos?.length === 0 && !loading}>
          {buscarTabela === '' ? (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={<> Nenhum registro disponível!</>}
            />
          ) : (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={
                <>
                  {' '}
                  <b>'{buscarTabela}'</b> não encontrado!
                </>
              }
            />
          )}
        </Render>

        <Render condition={loading}>
          <Carregando
            animation
            legenda='Carregando aditivos...'
            justifyContent='center'
            height={400}
            size='default'
          />
        </Render>
      </BodyTable>
    </Box>
  )
}
